<template>
  <a
    class="button"
    :class="{
      'button-green-branding-fix': color === 'green',
      'button-black': color === 'black',
      'button-yellow-score': color === 'yellow',
      'button-white': color === 'white',
      'mb-wp-100': fullWidthMobile,
    }"
    :href="sendMail ? mailTo : goToGroupDesign"
    target="_blank"
  >
    {{ title }}
    <img
      v-if="shouldShowicon"
      class="ml-8 w-17"
      :src="`${ASSETS_CDN}/icons/arrow_outward.svg`"
      alt="arrow outward"
    />
  </a>
</template>

<script setup>
import {assetCDN} from '~/helper/index.js'
import { computed } from 'vue'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import { useRoute } from 'vue-router'
import { SCHOOL_CONTACT_LINK } from '~/constant/schoolTourDetails'

// eslint-disable-next-line no-undef
defineProps({
  title: {
    type: String,
    default: 'Start Designing Now',
  },
  color: {
    type: String,
    default: 'green',
  },
  fullWidthMobile: {
    type: Boolean,
    default: true,
  },
  sendMail: {
    type: Boolean,
    default: false,
  },
  shouldShowicon: {
    type: Boolean,
    default: true,
  },
})

const ASSETS_CDN = assetCDN()
const route = useRoute()

const goToGroupDesign = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return `${SCHOOL_CONTACT_LINK}`
  return `${useAppConfig().publicDomainAgent}/design/group-trip-details`
})

const mailTo = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return `${SCHOOL_CONTACT_LINK}`
  return `mailto:travel@designerjourneys.com`
})
</script>

<style lang="scss" scoped>
a:link,
a:visited,
a:hover,
a:active,
a:focus {
  color: unset;
}

.button-black {
  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    color: #fff;
  }

  img {
    filter: invert(96%) sepia(98%) saturate(7%) hue-rotate(160deg)
      brightness(104%) contrast(101%);
  }
}

.button-white {
  border-radius: 1000px;
}
</style>
